import * as React from 'react';
import {Link} from 'react-router-dom';

export const covidWarning = <p style={{fontWeight: 'bold', fontStyle: 'italic'}}>
	Please note that our in-home hospice services are currently on hold, due to the COVID-19 pandemic, in an effort to
	support the increased demand for peaceful euthanasia at home. We do, however, offer a <Link
	to="/our-services/telehospice" className="inline-link">Telehospice</Link> service that will
	connect you to one of our knowledgeable hospice veterinarians via phone or video chat.
</p>;

export const veterinaryHospiceText1 = (
	<>
		<p>
			Veterinary hospice for dogs and cats is a family-focused, medically supervised,
			team-oriented service that is dedicated to maintaining the comfort and quality
			of life for terminally ill or senior pets until a natural death occurs or the
			family elects euthanasia.
		</p>
		<p>
			Originally modeled after human hospice, this specific type of care is focused on
			the comfort of your pet, not on finding a cure for their illness or disease. Please
			note that veterinary hospice appointments are scheduled as needed and does not include
			routine care (daily or weekly visits), any blood work, or diagnostic services. Our goal
			is to maintain the bond between humans and animals while focusing on comfort and education
			for families on providing palliative care.
		</p>
		<p>
			Hearing the dreaded words “there’s nothing else we can do” doesn’t mean that your
			only option is euthanasia. Veterinary hospice care is a unique approach to the
			needs your pet has at the end of their life. This approach focuses specifically on
			managing symptoms and maintaining their happiness for as long as possible.
		</p>
	</>
);

export const veterinaryHospiceText2 = (
	<>
		<p>
			You might have already received your pet’s diagnosis of a terminal illness or are managing advanced aging in
			your pet (see <Link className="inline-link"
								to="/resource-center/symptom-management/geriatric-veterinary-patients">Geriatric
			Care</Link>). Or maybe you need to buy
			some time before your family has a chance to say goodbye. Whatever your case may be,
			we promise we’ve heard it all.
		</p>
		<p>
			There is always more we can do to help ease the process of death. Pain medications
			with proper instructions on dosages, along with a specific and powerful symptom
			management protocol, are essential tools for easing everyone’s peace of mind.
		</p>
		<p>
			Hospice care revolves around the client-doctor relationship while adding
			interdisciplinary supplemental services to help support the family. The most important
			aspect of hospice care is education about your pet’s medical condition, and this is
			what our veterinarians spend the most time on.
		</p>
		<p>
			Once your family and our Lap of Love veterinarian create a custom care plan for your loved one,
			you will also be supported by a full hospice care team, including our dedicated hospice care
			nurses. Our nurses will work alongside your hospice veterinarian to provide you with timely
			support, guidance, and resources.
		</p>
		<p>
			You deserve to have all the information you can get in order to make the best decision
			for your family and your pet. And, while we cannot make that decision for you, we can
			assist you by sharing our medical knowledge to help you make a plan that meets the needs
			of your pet and respects the wishes of your family.
		</p>
	</>
);

export const veterinaryHospiceText3 = (
	<ul>
		<li>Education about the end-stage disease process</li>
		<li>Symptom management</li>
		<li>Pain recognition and treatment</li>
		<li>Supplementary nutrition</li>
		<li>Management of incontinence</li>
		<li>Environmental recommendations</li>
		<li>Mobility support</li>
	</ul>
);

export const veterinaryHospiceText4 = (
	<>
		<p>
			When euthanasia isn’t an option for personal or religious reasons, a “natural passing”
			is typically selected in its place.
		</p>
		<p>
			Before you decide a natural passing is right for your family, there are some very
			important things to note. If you are not in the mind space to hear sensitive information,
			we encourage you to skip this section, as you might find it upsetting.
		</p>
		<p>
			A true “natural death” is not quick or painless. In nature, predators remove the weakest
			or slowest animal from the pack, and they do this by force and violence. But our pets
			are not in a natural environment—if they were, most would not reach old age.
			Therefore, a “natural passing” is really more like an “unassisted biological death.”
		</p>
		<p>
			While it’s true that some pets (and humans) will simply close their eyes and not wake
			up, that’s rarely the case. Medical euthanasia allows your pet to “go to sleep and not
			wake up,” whereas Mother Nature doesn't. The kind of natural death a pet will
			experience is dependent upon the primary disease the pet has been diagnosed with.
			For example, heart failure results in the lungs filling up with fluid, and therefore—please
			read this with caution—a pet drowning to death. In short, death occurs when the brain
			fails to receive adequate levels of oxygen. And as you may know or can imagine, how
			this happens—how long it takes to fully occur and the mental state of your pet during
			this process—isn't an easy thing to witness.
		</p>
		<p>
			Please keep in mind that, although the above paints a gloomy picture of unassisted
			biological death, it is intended to address the most common reasons why families shy
			away from euthanasia. However, death will occur whether or not euthanasia is chosen.
			Death is the opposite of birth, not the opposite of life, and our species passes away
			without these medications every day.
		</p>
		<p>
			Please note: Although not the primary goal of veterinary hospice, an unassisted death
			can be honored and supported the same way euthanasia is.
		</p>
	</>
);

export const videoTitle = 'Reaching the end together.';
export const videoText = (
	<>
		<p>
			When it comes to the end-of-life stage for your pet, there are many things that can be done at home to make
			them more comfortable. Visit the <Link className="inline-link" to={'/resource-center'}>Resource Center</Link> on
			our website to get more information. We also encourage you to speak with your
			family’s veterinarian about additional comfort-oriented care for your pet.
		</p>
		<p>
			And if you'd find it helpful to connect with other families who have been through
			this difficult process, please visit our <a className="inline-link"
														href="https://www.facebook.com/lapoflove" target="_blank">
			Facebook page</a> to read their posts and listen
			to their stories.
		</p>
	</>
);
export const videoUrl = 'https://www.youtube.com/embed/jWsza3g7k5Q?showinfo=0';